import React from "react";
import { View, StyleSheet } from "react-native";

export default function ActivityColor({ color }) {
  return (
    <>
      {color ? (
        <View style={[styles.dot, { backgroundColor: color }]}></View>
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  dot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    marginHorizontal: 5,
  },
});
